module.exports = __webpack_public_path__ + "static/media/cybercrime-large@2x.719175ea.png";